import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import { eventChannel, END } from 'redux-saga';
import axios from "axios";
import {client} from "apollo/client";
import {
  auth,
  facebookAuthProvider,
  githubAuthProvider,
  googleAuthProvider,
  twitterAuthProvider
} from "../../firebase/firebase";
import {
  SIGNIN_FACEBOOK_USER,
  SIGNIN_GITHUB_USER,
  SIGNIN_GOOGLE_USER,
  SIGNIN_TWITTER_USER,
  SIGNIN_USER,
  SIGNOUT_USER,
  SIGNUP_USER,
  REFRESHTOKEN_USER,
  REFRESHTOKEN_USER_INTERVAL,
  CHANGEPASSWORD,
  CHANGEPASSWORD_SUCCESS,
  FORGOTPASSWORD,
  CONFIRMFORGOTPASSWORD,
  UPDATEACCOUNT,
  DELETEACCOUNT,
  ENABLEACCOUNT,
  DISABLEACCOUNT,
  CHECKTYPE_USER,
  GETACCOUNT,
  GETACCOUNT_SUCCESS
} from "constants/ActionTypes";
import {fetchError} from "../../appRedux/actions/Common";
import {showAuthMessage, userSignInSuccess, userSignOutSuccess, userSignUpSuccess, userRefreshTokenSuccess,
userCheckType} from "../../appRedux/actions/Auth";
import {fetchApplications} from "../../appRedux/actions/Application";
import {
  userFacebookSignInSuccess,
  userGithubSignInSuccess,
  userGoogleSignInSuccess,
  userTwitterSignInSuccess,
  changePasswordSuccess,
  forgotPasswordSuccess,
  confirmForgotPasswordSuccess,
  updateAccountSuccess,
  deleteAccountSuccess,
  userCheckTypeSuccess,
  getAccountSuccess,
  enableAccountSuccess,
  disableAccountSuccess
} from "../actions/Auth";

import {getAccount} from "apollo/queries/getAccount";
import {updateAccountMutation} from "apollo/mutations/updateAccount";
import {deleteAccountMutation} from "apollo/mutations/deleteAccount";
import {enableAccountMutation} from "apollo/mutations/enableAccount";
import {disableAccountMutation} from "apollo/mutations/disableAccount";

const createUserWithEmailPasswordRequest = async (username, email, password) =>
  await axios({
    method: 'POST',
    url: 'https://bms-api.viatick.com/' + process.env.REACT_APP_STAGE + '/api/oauth2/signup',
    headers: { 'content-type': 'application/json' },
    data: {
      username: username,
      email: email,
      password: password
    }
  })
    .then(authUser => authUser)
    .catch(error => error);

const signInUserWithEmailPasswordRequest = async (email, password) => {
  return await axios({
    method: 'POST',
    url: 'https://bms-api.viatick.com/' + process.env.REACT_APP_STAGE + '/api/oauth2/authorize',
    headers: { 'content-type': 'application/json' },
    data: {
      email: email,
      password: password
    }
  })
    .then(authUser => authUser)
    .catch(error => error);
}

const checkTypeRequest = async (payload) => {
  return await axios({
    method: 'POST',
    url: 'https://bms-api.viatick.com/' + process.env.REACT_APP_STAGE + '/api/oauth2/type/check',
    headers: { 'content-type': 'application/json' },
    data: {
      authorization: "Bearer " + localStorage.getItem('bms_access_token')
    }
  })
    .then(authUser => authUser)
    .catch(error => error);
}

const changePasswordRequest = async (previousPassword, proposedPassword) => {
  return await axios({
    method: 'POST',
    url: 'https://bms-api.viatick.com/' + process.env.REACT_APP_STAGE + '/api/oauth2/password/change',
    headers: { 'content-type': 'application/json' },
    data: {
      accessToken: localStorage.getItem('bms_access_token'),
      previousPassword: previousPassword,
      proposedPassword: proposedPassword
    }
    })
  .then(authUser => authUser)
  .catch(error => error);
}

const forgotPasswordRequest = async (email) => {
  console.log('forgotPasswordRequest', email);

  return await axios({
    method: 'POST',
    url: 'https://bms-api.viatick.com/' + process.env.REACT_APP_STAGE + '/api/oauth2/password/forgot',
    headers: { 'content-type': 'application/json' },
    data: {
      email
    }
    })
    .then(authUser => authUser)
    .catch(error => error);
}

const confirmForgotPasswordRequest = async (email, confirmationCode, password) => {
  console.log('confirmForgotPasswordRequest', email, confirmationCode, password);
  return await axios({
    method: 'POST',
    url: 'https://bms-api.viatick.com/' + process.env.REACT_APP_STAGE + '/api/oauth2/password/forgot/confirm',
    headers: { 'content-type': 'application/json' },
    data: {
      email,
      confirmationCode,
      password
    }
    })
    .then(authUser => authUser)
    .catch(error => error);
}


const refreshTokenRequest = async (refreshToken) =>
      await axios({
        method: 'POST',
        url: 'https://bms-api.viatick.com/' + process.env.REACT_APP_STAGE + '/api/oauth2/token',
        headers: {
          grant_type: 'refresh_token',
          refresh_token: refreshToken
        },
        data: {
        }
      })
        .then(refreshTokenResponse => refreshTokenResponse)
        .catch(error => error);

const signOutRequest = async () =>
  await  auth.signOut()
    .then(authUser => authUser)
    .catch(error => error);


const signInUserWithGoogleRequest = async () =>
  await  auth.signInWithPopup(googleAuthProvider)
    .then(authUser => authUser)
    .catch(error => error);

const signInUserWithFacebookRequest = async () =>
  await  auth.signInWithPopup(facebookAuthProvider)
    .then(authUser => authUser)
    .catch(error => error);

const signInUserWithGithubRequest = async () =>
  await  auth.signInWithPopup(githubAuthProvider)
    .then(authUser => authUser)
    .catch(error => error);

const signInUserWithTwitterRequest = async () =>
  await  auth.signInWithPopup(twitterAuthProvider)
    .then(authUser => authUser)
    .catch(error => error);

const updateAccountRequest = async (input) => {
  let { data, error } = await client.mutate({
    mutation: updateAccountMutation,
    variables: {
      input
    }
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const enableAccountRequest = async (input) => {
  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: enableAccountMutation,
      variables: {
        input: {
          accountId: input
        }
      }
    });

    return Promise.resolve(data.enableAccount);
  } catch (e) {
    return Promise.reject(e);
  }
}

const disableAccountRequest = async (input) => {
  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: disableAccountMutation,
      variables: {
        input: {
          accountId: input
        }
      }
    });

    return Promise.resolve(data.disableAccount);
  } catch (e) {
    return Promise.reject(e);
  }
}

const deleteAccountRequest = async (input) => {
  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: deleteAccountMutation,
      variables: {
        accountId: input
      }
    });

    if (data.deleteAccountById.rows_deleted > 0) {
      return Promise.resolve(data);
    } else {
      return Promise.reject("Account not found");
    }
  } catch (e) {
    return Promise.reject(e);
  }
}

const getAccountRequest = async () => {
  let { data, error } = await client.query({
    query: getAccount,
    variables: {
    },
    fetchPolicy: 'network-only'
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

function* createUserWithEmailPassword({payload}) {
  const {username, email, password} = payload;
  try {
    const signUpUser = yield call(createUserWithEmailPasswordRequest, username, email, password);
    if (signUpUser.status != 200) {
      yield put(fetchError(signUpUser.response.data));
    } else {
      yield put(userSignUpSuccess(signUpUser.data));
    }
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* signInUserWithGoogle() {
  try {
    const signUpUser = yield call(signInUserWithGoogleRequest);
    if (signUpUser.message) {
      yield put(showAuthMessage(signUpUser.message));
    } else {
      localStorage.setItem('user_id', signUpUser.user.uid);
      yield put(userGoogleSignInSuccess(signUpUser.user.uid));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}


function* signInUserWithFacebook() {
  try {
    const signUpUser = yield call(signInUserWithFacebookRequest);
    if (signUpUser.message) {
      yield put(showAuthMessage(signUpUser.message));
    } else {
      localStorage.setItem('user_id', signUpUser.user.uid);
      yield put(userFacebookSignInSuccess(signUpUser.user.uid));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}


function* signInUserWithGithub() {
  try {
    const signUpUser = yield call(signInUserWithGithubRequest);
    if (signUpUser.message) {
      yield put(showAuthMessage(signUpUser.message));
    } else {
      localStorage.setItem('user_id', signUpUser.user.uid);
      yield put(userGithubSignInSuccess(signUpUser.user.uid));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}


function* signInUserWithTwitter() {
  try {
    const signUpUser = yield call(signInUserWithTwitterRequest);
    if (signUpUser.message) {
      if (signUpUser.message.length > 100) {
        yield put(showAuthMessage('Your request has been canceled.'));
      } else {
        yield put(showAuthMessage(signUpUser.message));
      }
    } else {
      localStorage.setItem('user_id', signUpUser.user.uid);
      yield put(userTwitterSignInSuccess(signUpUser.user.uid));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

function* signInUserWithEmailPassword({payload}) {
  const {email, password} = payload;
  try {
    const signInUser = yield call(signInUserWithEmailPasswordRequest, email, password);
    if (signInUser.status != 200) {
      console.log('signInUser', signInUser.response);
      yield put(fetchError(signInUser.response.data));
    } else {
      localStorage.setItem('bms_access_token', signInUser.data.AuthenticationResult.AccessToken);
      localStorage.setItem('bms_refresh_token', signInUser.data.AuthenticationResult.RefreshToken);
      localStorage.setItem('user_id', signInUser.data.AuthenticationResult.IdToken);
      yield put(userCheckType());
      yield put(fetchApplications());
      yield put(userSignInSuccess(signInUser.data.AuthenticationResult.AccessToken));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

function* checkTypeCall({payload}) {
  try {
    const checkedType = yield call(checkTypeRequest, payload);
    console.log('checkedType', checkedType);
    if (checkedType.status != 200) {
      console.log('signInUser', signInUser.response);
      yield put(fetchError(checkedType.response.data));
    } else {
      yield put(userCheckTypeSuccess(checkedType.data));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

function* refreshTokenUser(payload) {
  console.log('refreshToken', refreshToken);
  const refreshToken = localStorage.getItem('bms_refresh_token');

  if (refreshToken) {
    try {
      const refreshTokenResponse = yield call(refreshTokenRequest, refreshToken);
      console.log('refreshTokenResponse', refreshTokenResponse);
      if (refreshTokenResponse.status != 200) {
        yield put(showAuthMessage(refreshTokenResponse.data));
      } else {
        localStorage.setItem('bms_access_token', refreshTokenResponse.data.AuthenticationResult.AccessToken);
        localStorage.setItem('bms_access_token_timeout', (new Date()).getTime() + 1200 * 1000);
        yield put(userRefreshTokenSuccess(refreshTokenResponse.data.AuthenticationResult.AccessToken));
        yield put(fetchApplications());
      }
    } catch (error) {
      yield put(showAuthMessage(error));
    }
  }
}

function* signOut() {
  localStorage.removeItem('user_id');
  localStorage.removeItem('bms_email');
  localStorage.removeItem('bms_access_token');
  localStorage.removeItem('bms_access_token_timeout');
  localStorage.removeItem('bms_refresh_token');
  localStorage.removeItem('bms_refresh_token');
  localStorage.removeItem('bms-current-application');
  // client.resetStore();
  // client.cache.writeData({ data: {} });
  yield put(userSignOutSuccess({}));
}

function refreshTokenChannel(secs, payload) {
  return eventChannel(emitter => {
      const nextTimeout = localStorage.getItem('bms_access_token_timeout') || 0;
      console.log('nextTimeout', nextTimeout);

      if (!nextTimeout || nextTimeout < (new Date().getTime())) {
        setTimeout(() => {
          emitter(payload)
        }, 500);
      }

      const iv = setInterval(() => {
        emitter(payload)
      }, 1000 * secs);

      // The subscriber must return an unsubscribe function
      return () => {
        clearInterval(iv)
      }
    }
  )
}

function* changePasswordCall({payload}) {
  const {previousPassword, proposedPassword} = payload;
  try {
    const changedPassword = yield call(changePasswordRequest, previousPassword, proposedPassword);
    if (changedPassword.status != 200) {
      yield put(fetchError(changedPassword.response));
    } else {
      yield put(changePasswordSuccess(changedPassword.data));
    }
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* forgotPasswordCall({payload}) {
  const {email} = payload;
  try {
    const res = yield call(forgotPasswordRequest, email);
    console.log('forgotPasswordCall', res);
    if (res.status != 200) {
      yield put(fetchError(res.response));
    } else {
      yield put(forgotPasswordSuccess(res.data));
    }
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* confirmForgotPasswordCall({payload}) {
  const {email, confirmationCode, password} = payload;
  try {
    const res = yield call(confirmForgotPasswordRequest, email,
    confirmationCode, password);
    if (res.status != 200) {
      yield put(fetchError(res.response));
    } else {
      yield put(confirmForgotPasswordSuccess(res.data));
    }
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* updateAccountCall({payload}) {
  console.log('payload', payload);

  try {
    const {updateAccount} = yield call(updateAccountRequest, payload);
    yield put(updateAccountSuccess(updateAccount));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* deleteAccountCall({payload}) {

  try {
    const deletedAccount = yield call(deleteAccountRequest, payload);
    yield put(deleteAccountSuccess(deletedAccount));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* enableAccountCall({payload}) {
  try {
    const enabledAccount = yield call(enableAccountRequest, payload);
    yield put(enableAccountSuccess(enabledAccount));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* disableAccountCall({payload}) {
  try {
    const disabledAccount = yield call(disableAccountRequest, payload);
    yield put(disableAccountSuccess(disabledAccount));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* getAccountCall({payload}) {

  try {
    const {getAccount} = yield call(getAccountRequest);
    yield put(getAccountSuccess(getAccount));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

export function* createUserAccount() {
  yield takeEvery(SIGNUP_USER, createUserWithEmailPassword);
}

export function* signInWithGoogle() {
  yield takeEvery(SIGNIN_GOOGLE_USER, signInUserWithGoogle);
}

export function* signInWithFacebook() {
  yield takeEvery(SIGNIN_FACEBOOK_USER, signInUserWithFacebook);
}

export function* signInWithTwitter() {
  yield takeEvery(SIGNIN_TWITTER_USER, signInUserWithTwitter);
}

export function* signInWithGithub() {
  yield takeEvery(SIGNIN_GITHUB_USER, signInUserWithGithub);
}

export function* signInUser() {
  yield takeEvery(SIGNIN_USER, signInUserWithEmailPassword);
}

export function* checkTypeUser() {
  yield takeEvery(CHECKTYPE_USER, checkTypeCall);
}

export function* changePassword() {
  yield takeEvery(CHANGEPASSWORD, changePasswordCall);
}

export function* forgotPassword() {
  yield takeEvery(FORGOTPASSWORD, forgotPasswordCall);
}

export function* confirmForgotPassword() {
  yield takeEvery(CONFIRMFORGOTPASSWORD, confirmForgotPasswordCall);
}

// export function* refreshToken() {
//   yield takeEvery(REFRESHTOKEN_USER, refreshTokenUser);
// }

export function* signOutUser() {
  yield takeEvery(SIGNOUT_USER, signOut);
}

export function* refreshTokenIntervalCall({payload}) {
  console.log('refreshTokenIntervalCall', payload);
  const channel = yield call(refreshTokenChannel, 600, payload);
  yield takeEvery(channel, refreshTokenUser);
}

export function* refreshTokenInterval() {
  console.log('refreshTokenInterval');
  yield takeEvery(REFRESHTOKEN_USER_INTERVAL, refreshTokenIntervalCall);
}

export function* updateAccount() {
  yield takeEvery(UPDATEACCOUNT, updateAccountCall);
}

export function* deleteAccount() {
  yield takeEvery(DELETEACCOUNT, deleteAccountCall);
}

export function* enableAccount() {
  yield takeEvery(ENABLEACCOUNT, enableAccountCall);
}

export function* disableAccount() {
  yield takeEvery(DISABLEACCOUNT, disableAccountCall);
}

export function* fetchAccount() {
  yield takeEvery(GETACCOUNT, getAccountCall);
}

export default function* rootSaga() {
  yield all([fork(signInUser),
    fork(createUserAccount),
    fork(signInWithGoogle),
    fork(signInWithFacebook),
    fork(signInWithTwitter),
    fork(signInWithGithub),
    fork(signOutUser),
    fork(refreshTokenInterval),
    fork(changePassword),
    fork(forgotPassword),
    fork(confirmForgotPassword),
    fork(updateAccount),
    fork(deleteAccount),
    fork(checkTypeUser),
    fork(fetchAccount),
    fork(enableAccount),
    fork(disableAccount)]);
}
